var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.84122 23.9419H6.9581V26.0558H4.84122V23.9419ZM11.7993 26.0558H17.0915V23.9419H11.7993V26.0558ZM0 17.444H10.4372V15.3302H0V17.444ZM8.32027 26.0558H10.4372V18.8043H8.32027V26.0558ZM6.9581 9.71462V6.36L0.782326 13.9699H3.50666L6.9581 9.71462ZM12.1123 0L11.7993 0.386011V3.74983L13.7597 1.33266L12.1123 0ZM15.2784 15.3302V17.444H18.9047V15.3302H15.2784ZM13.9162 3.29948L11.7993 5.90965V22.5817H13.9162V3.29948ZM8.32027 13.9699H10.4372V2.06792L8.32027 4.67809V13.9699Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 26
  })))));
}

export default Svg4;